const showModalStopQuiz = (state) => {
  return {
    ...state,
    alertStopQuiz: true
  }
}

export default showModalStopQuiz